/* import __COLOCATED_TEMPLATE__ from './rename-group-modal.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent-2 */

import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type PlaygroundApiService from 'embercom/services/playground-api';
import type { Playground } from 'embercom/lib/fin-playground/playground';
import { localCopy } from 'tracked-toolbox';
import { ResponseError } from 'embercom/lib/inbox/requests';

interface RenameGroupModalArgs {
  onClose: () => void;
  playground: Playground;
}

export default class RenameGroupModal extends Component<RenameGroupModalArgs> {
  @service declare playgroundApi: PlaygroundApiService;
  @service declare notificationsService: $TSFixMe;
  @service declare intl: $TSFixMe;
  @localCopy('args.playground.groupName') declare groupName: string;

  get disableSaveButton() {
    return this.groupName.trim() === '' || this.groupName === this.args.playground.groupName;
  }

  @action async renameGroup() {
    let originalGroupName = this.args.playground.groupName;

    try {
      if (!this.args.playground.id) {
        return;
      }

      this.args.playground.updateGroupName(this.groupName);
      await this.playgroundApi.updatePlaygroundGroup(this.args.playground.id, this.groupName);
      this.args.onClose();
    } catch (err) {
      if (err instanceof ResponseError && err.response.status === 404) {
        this.notificationsService.notifyError(
          this.intl.t('ai-agent.playground.banners.group-deleted-error'),
        );
      }

      if (originalGroupName) {
        this.args.playground.updateGroupName(originalGroupName);
      }
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Playground::Modals::RenameGroupModal': typeof RenameGroupModal;
  }
}
